import * as React from "react";

import {
  createStyles,
  makeStyles,
  Theme,
  useTheme,
} from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import FormControl, { FormControlProps } from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Popover from "@material-ui/core/Popover";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";

import { FieldRenderProps } from "react-final-form";

import * as _ from "lodash";

// import moment from "moment";
// import * as Moment from "moment";
// import { extendMoment } from "moment-range";

// const moment = extendMoment(Moment);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      // margin: theme.spacing(0),
      // paddingLeft: theme.spacing(1),
      // paddingRight: theme.spacing(1),
    },
    formControl: {
      minWidth: "150px",
      margin: theme.spacing(0, 1),
    },
  })
);

interface Props extends FieldRenderProps<any, any> {
  label?: string;
  formControlProps?: FormControlProps;
}

function DateRangeDateTimeFieldRender(props: Props) {
  const {
    input: { name, value, onChange, ...restInput },
    meta,
    label,
    formControlProps,
    ...rest
  } = props;
  const showError =
    ((meta.submitError && !meta.dirtySinceLastSubmit) || meta.error) &&
    meta.touched;

  const classes = useStyles(props);
  const theme = useTheme() as Theme;
  // const fullWidth = useMediaQuery(theme.breakpoints.down("xs"));
  // const context = useContext(IntervalSelectContext);

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<null | HTMLDivElement>(null);
  const [dateTimeAmount, setDateTimeAmount] = React.useState(1);
  const [dateTimeUnit, setDateTimeUnit] = React.useState("D");

  function handleClose(event: React.MouseEvent<Document>) {
    // if (anchorRef.current && anchorRef.current.contains(event.target)) {
    //   return;
    // }

    setOpen(false);
  }

  function handleDateTimeAmountChange(event: any) {
    setDateTimeAmount(event.target.value);
  }

  function handleDateTimeUnitChange(event: any) {
    setDateTimeUnit(event.target.value);
  }

  // function startDateFn(
  //   startDate: moment.Moment,
  //   endDate: moment.Moment,
  //   startDateTouched: boolean,
  //   duration: moment.Duration
  // ) {
  //   return !startDateTouched
  //     ? moment(endDate).subtract(duration).add(1, "second").startOf("day")
  //     : startDate;
  // }
  // function endDateFn(
  //   startDate: moment.Moment,
  //   endDate: moment.Moment,
  //   startDateTouched: boolean,
  //   duration: moment.Duration
  // ) {
  //   return !!startDateTouched
  //     ? moment(startDate).add(duration).subtract(1, "second").endOf("day")
  //     : endDate;
  // }

  // TODO Copy&Paste of global-date-picker!
  const quickItems = [
    // {
    //   id: "-",
    //   name: "None",
    //   interval: undefined
    // },
    {
      id: "today",
      name: "Today",
      interval: {
        startDate: "now/d",
        endDate: "now/d",
      },
      periodDuration: "P1D",
    },
    {
      id: "yesterday",
      name: "Yesterday",
      interval: {
        startDate: "now-1d/d",
        endDate: "now-1d/d",
      },
      periodDuration: "P1D",
    },
    {
      id: "thisWeek",
      name: "This week",
      interval: {
        startDate: "now/w",
        endDate: "now/w",
      },
      periodDuration: "P1W",
    },
    {
      id: "weekToDate",
      name: "Week to date",
      interval: {
        startDate: "now/w",
        endDate: "now/d",
      },
      periodDuration: "P1W",
    },
    {
      id: "thisMonth",
      name: "This month",
      interval: {
        startDate: "now/M",
        endDate: "now/M",
      },
      periodDuration: "P1M",
    },
    {
      id: "monthToDate",
      name: "Month to date",
      interval: {
        startDate: "now/M",
        endDate: "now/d",
      },
      periodDuration: "P1M",
    },
    {
      id: "thisYear",
      name: "This Year",
      interval: {
        startDate: "now/y",
        endDate: "now/y",
      },
      periodDuration: "P1Y",
    },
    {
      id: "yearToDate",
      name: "Year to date",
      interval: {
        startDate: "now/y",
        endDate: "now/d",
      },
      periodDuration: "P1Y",
    },
  ];
  const rangeItems = [
    // {
    //   id: "-",
    //   name: "None",
    //   interval: undefined
    // },
    {
      id: "1day",
      name: "1 Day",
      interval: {
        startDate: "now/d",
        endDate: "now/d",
      },
      periodDuration: "P1D",
    },
    {
      id: "2days",
      name: "2 Days",
      interval: {
        startDate: "now-1d/d",
        endDate: "now/d",
      },
      periodDuration: "P2D",
    },
    {
      id: "1week",
      name: "1 Week",
      interval: {
        startDate: "now/w",
        endDate: "now/w",
      },
      periodDuration: "P7D", // TODO "P1W"
    },
    {
      id: "2weeks",
      name: "2 Weeks",
      interval: {
        startDate: "now-1w/w",
        endDate: "now/w",
      },
      periodDuration: "P14D", // TODO "P2W"
    },
    {
      id: "30days",
      name: "30 Days",
      interval: {
        startDate: "now-30d/d",
        endDate: "now/d",
      },
      periodDuration: "P30D",
    },
    {
      id: "60days",
      name: "60 Days",
      interval: {
        startDate: "now-60d/d",
        endDate: "now/d",
      },
      periodDuration: "P60D",
    },
    {
      id: "90days",
      name: "90 Days",
      interval: {
        startDate: "now-90d/d",
        endDate: "now/d",
      },
      periodDuration: "P90D",
    },
    {
      id: "120days",
      name: "120 Days",
      interval: {
        startDate: "now-120d/d",
        endDate: "now/d",
      },
      periodDuration: "P120D",
    },
    {
      id: "1year",
      name: "1 Year",
      interval: {
        startDate: "now/y",
        endDate: "now/y",
      },
      periodDuration: "P1Y",
    },
    {
      id: "<CUSTOM>",
      name: "Custom",
      interval: {
        startDate: "",
        endDate: "",
      },
      periodDuration: "<CUSTOM>",
    },
  ];

  const keyed = _.keyBy([...quickItems, ...rangeItems], "id");
  // const keyedByPeriodDuration = _.keyBy([...rangeItems], "periodDuration");

  // const data = {
  //   durationSelect: value,
  // };

  // function handleStartDateChange(date: Date | null) {
  //   // TODO update durations, etc.
  //   const startDateTouched = true;
  //   const startDate = date ? moment(date) : moment();
  //   const endDate = endDateFn(
  //     startDate,
  //     moment(data.durationSelect.endDate),
  //     startDateTouched,
  //     moment.duration(data.durationSelect.duration)
  //   );
  //   // client.writeData({
  //   //   data: {
  //   //     durationSelect: {
  //   //       __typename: "DurationSelect",
  //   //       startDateTouched,
  //   //       startDate: startDate.toJSON(),
  //   //       endDate: endDate.toJSON(),
  //   //     },
  //   //   },
  //   // });
  // }
  const handleDateRangeSelectChange = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    const durationId = event.target.value;

    if (durationId === "<CUSTOM>") {
      setOpen(true);
      // TODO
      return;
    }
    // if (durationId === "<DEFAULT>") {
    //   return onChange(
    //     ({ startDate: undefined, endDate: undefined })
    //   );
    // }
    handleDateRangeChange(durationId);
  };
  const handleDateRangeChange = (durationId: any) => {
    // console.log("handleDateRangeChange ", durationId);
    // const item = rangeItems.find((item) => item.id === durationId);
    const item = keyed[durationId];
    // console.log("found date item ", item);
    return onChange(
      item
        ? item.interval
        : durationId === "<DEFAULT>"
        ? { startDate: undefined, endDate: undefined }
        : { startDate: `now-${dateTimeAmount}d/d`, endDate: `now/d` }
    );
    // https://github.com/dangrossman/daterangepicker/blob/master/daterangepicker.js#L491
    //const endDate = !!startDateTouched ? moment(endDate).add(1,"d").startOf("day").subtract(1,"second") : endDate;
    // client.writeData({
    //   data: {
    //     durationSelect: {
    //       __typename: "DurationSelect",
    //       durationISO,
    //       duration: duration.toISOString(),
    //       startDate: startDate.toJSON(),
    //       endDate: endDate.toJSON(),
    //     },
    //   },
    // });
    // if (localStorage) {
    //   localStorage.setItem("lastTimeRange", duration.toISOString());
    // }
  };

  // function handleJumpDate(pd: string) {
  //   handleStartDateChange(
  //     moment(data.durationSelect.startDate).add(moment.duration(pd)).toDate()
  //   );
  //   // setSelectedDate(moment(selectedDate ? selectedDate : new Date()).add(moment.duration(pd)).toDate());
  // }

  const x = value
    ? rangeItems.find(
        (item) =>
          item.interval.startDate === value.startDate &&
          item.interval.endDate === value.endDate
      )
    : undefined;

  let myValue: string;
  if (x) {
    myValue = x.id;
  } else {
    myValue =
      value && (value.startDate || value.endDate) ? "<CUSTOM>" : "<DEFAULT>";
  }
  // const isDefault = !x || !value.startDate;
  // const myValue = !x
  //   ? "<DEFAULT>"
  //   : (data.durationSelect.durationISO in keyedByPeriodDuration) ? keyedByPeriodDuration[data.durationSelect.durationISO].id : "<CUSTOM>";
  // console.log("isdefault: ", isDefault, value, data, data.durationSelect.durationISO, keyedByPeriodDuration[data.durationSelect.durationISO], myValue);

  // const selectedDurationObject = keyed[value];
  // const selectedDurationObjectSuffix = selectedDurationObject.periodDuration.substring(
  //   1
  // );
  // const selectedDurationObjectSuffix = data.durationSelect.durationISO.substring(
  //   1
  // );

  // TODO all

  // const x = value
  //   ? rangeItems.find(
  //       (item) =>
  //         item.interval.startDate === value.startDate &&
  //         item.interval.endDate === value.endDate
  //     )
  //   : undefined;
  // const myValue = x ? x.id : "<DEFAULT>";
  // TODO what if not found? (custom / none = inherit from dashboard / ...)
  return (
    <>
      <FormControl {...formControlProps} error={showError}>
        <InputLabel htmlFor={name}>{label}</InputLabel>

        <Select
          {...rest}
          ref={anchorRef}
          name={name}
          onChange={handleDateRangeSelectChange}
          // onChange={(evt) => {
          //   const item = rangeItems.find((item) => item.id === evt.target.value);
          //   // console.log("found date item ", item);
          //   return onChange(
          //     item ? item.interval : { startDate: undefined, endDate: undefined }
          //   );
          // }}
          inputProps={{ /*endAdornment,*/ ...restInput }}
          value={myValue}
          // IconComponent={DateRangeIcon}
        >
          <MenuItem value="<DEFAULT>">Default</MenuItem>
          {/* {quickItems &&
          quickItems.map((item: any) => (
            <MenuItem key={item.id} value={item.id}>
              {item.name}
            </MenuItem>
          ))}
          <Divider /> */}
          {rangeItems &&
            rangeItems.map((item: any) => (
              <MenuItem key={item.id} value={item.id}>
                <div
                  onClick={() => {
                    if (item.id === "<CUSTOM>") {
                      setOpen(true);
                    }
                  }}
                >
                  {item.name}
                </div>
              </MenuItem>
            ))}
          {/* <MenuItem key="<CUSTOM>" value="<CUSTOM>">
            Custom
          </MenuItem> */}
        </Select>

        {showError && (
          <FormHelperText>{meta.error || meta.submitError}</FormHelperText>
        )}
      </FormControl>
      <Popover
        // id={id}
        open={open}
        anchorEl={anchorRef.current}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div style={{ margin: theme.spacing(1) }}>
          {/* TODO other units (week, month, year, ...) */}
          <Grid container spacing={1}>
            <Grid item xs={12} md>
              <TextField
                id="datetimeamount"
                label="Amount"
                // defaultValue="1"
                type="number"
                value={dateTimeAmount}
                required
                fullWidth
                // InputLabelProps={{
                //   shrink: true,
                // }}
                // InputProps={{
                //   endAdornment: (
                //     <InputAdornment position="end">Days</InputAdornment>
                //   ),
                // }}
                onChange={handleDateTimeAmountChange}
              />
            </Grid>
            <Grid item xs={12} md>
              <FormControl className={classes.formControl} fullWidth>
                <InputLabel id="datetimeunit-label">Unit</InputLabel>
                <Select
                  labelId="datetimeunit-label"
                  id="datetimeunit"
                  value={dateTimeUnit}
                  onChange={handleDateTimeUnitChange}
                >
                  <MenuItem value={"H"}>Hours</MenuItem>
                  <MenuItem value={"D"}>Days</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                className={classes.button}
                color="primary"
                // type="submit"
                // disabled={submitting || invalid}
                onClick={(e) => {
                  handleDateRangeChange(
                    `P${
                      dateTimeUnit === "H" ? "T" : ""
                    }${dateTimeAmount}${dateTimeUnit}`
                  );
                  setOpen(false);
                }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </div>
      </Popover>
    </>
  );
}

export default DateRangeDateTimeFieldRender;
